import { ksFacturesAPayerQK, ksFacturesQK } from '@/lib/query-keys';
import { facturesService } from '@/lib/services/factures.service';
import {
  CreatePdfFacturePayload,
  CreateStripeCheckoutSessionPourFacturePayload,
} from '@/lib/interfaces/factures.interface';
import { useMutation, useQuery } from '@tanstack/react-query';

export const useFactures = () => {
  return useQuery({
    queryKey: [ksFacturesQK],
    queryFn: facturesService.getFactures,
  });
};

export const useFacture = (factureId: string | null) => {
  return useQuery({
    queryKey: [ksFacturesQK, factureId],
    queryFn: () => facturesService.getFacture(factureId as string),
    enabled: !!factureId,
  });
};

export const useFacturesAPayer = () => {
  return useQuery({
    queryKey: [ksFacturesAPayerQK],
    queryFn: facturesService.getFacturesAPayer,
  });
};

export const useFactureDownloadUrl = () => {
  return useMutation({
    mutationFn: (factureId: string) => facturesService.getDownloadUrl(factureId),
    onSuccess: (url: string) => {
      window.open(url, "_blank");
    },
    onError: (error) => {
      console.error(error);
      return null;
    },
  });
};

export const useCreatePdfFacture = () => {
  return useMutation({
    mutationFn: (payload: CreatePdfFacturePayload) => facturesService.createPdf(payload),
  });
};

export const useCreateStripeCheckoutSessionPourFacture = () => {
  return useMutation({
    mutationFn: (payload: CreateStripeCheckoutSessionPourFacturePayload) =>
      facturesService.createStripeCheckoutSessionPourFacture(payload),
  });
};
